/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

const IconLinkTabNav = (props) => {
    const { tabs, selectTab } = props;

    return (
        <div className="icon-link-tab-nav-wrapper">
            {tabs?.map((tab, index) => {
                return (
                    <button
                        key={tab?.guid}
                        data-tab-index={index}
                        role="tab"
                        tabIndex={index}
                        aria-selected={tab?.isVisible}
                        aria-controls={tab?.guid}
                        id={tab?.guid}
                        onClick={(event) => selectTab(event, tab?.guid)}
                        className={tab?.isVisible ? "active" : ""}
                    >
                        <span>{tab?.title}</span>
                    </button>
                );
            }
            )}
        </div>
    );
};

IconLinkTabNav.displayName = "IconLinkTabNav";
export { IconLinkTabNav };
